import regexMap from '../scripts/constants/regex-map';

/**
 * @param  {array} options - list of toggle option objects, e.g. travelerFormOptions.GENDER
 * @param  {string} value - value saved to ui model
 * @return {object} initial form dropdown value
 */
export function getInitialToggleValue(options, value) {
  const i = options.findIndex(option => option.value === value);

  return {
    index: i,
    toggle: value,
  };
}

/**
 * Parses a segment code (e.g. ACA_MEX_AM_09-24-2016_1030) into an object { departure: string, arrival: string, date: Date}
 * or returns null if code is invalid.
 */
export function parseSegmentCode(segmentCode) {
  const segmentCodeRegex = '^([A-Z]{3})_([A-Z]{3})_[A-Z0-9]{2}_([0-9]{4})-([0-9]{2})-([0-9]{2})_([0-9]{4})$';

  const match = segmentCode.match(segmentCodeRegex);

  if (!match) {
    return null;
  } else {
    const [
      depAirportCode,
      arrAirportCode,
      depYear,
      depMonth,
      depDay,
    ] = match;

    return {
      departure: depAirportCode,
      arrival: arrAirportCode,
      // Months in Date are 0-based hence the 'depMonth - 1'
      // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
      date: new Date(depYear, (depMonth - 1), depDay),
    };
  }
}

/**
 * @param {String} str - string to reformat
 */
export function toTitleCase(str) {
  if (str !== null) {
    return str.replace(regexMap.ALL_CHARS, txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  } else {
    return false;
  }
}

/**
 * Sanitize email separated list
 *
 * @param {string} value - comma separated list
 *
 * @return {string}
 */
export function transformCommaSeparatedEmailList(value) {
  return value.replace( /\s/g, '' );
}
